import React, { useCallback, useEffect, useState } from "react";

import { getMethodNames, getModuleNames, getNews, getTags, updateNews } from "services";

import { incomplete, useCancelAsyncOnUnmount, useNavigate, useParams } from "utils";

import { AdminHead, Button, Col, ErrorBoundary, Form, MainPage, ModalContent, Row, Message as message } from "components";

import { NewsInputs } from "pages/admin/content/components/NewsInputs";

export const NewsUpdate = () => {
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [methods, setMethods] = useState([]);
  const [modules, setModules] = useState([]);
  const [imageSuccess, setImageSuccess] = useState(false);
  const [imageURL, setImageURL] = useState(false);
  const [content, setContent] = useState("");
  const [news, setNews] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();

  const { id } = useParams();

  const loadTags = useCallback(
    (language) => {
      getTags({
        language,
        signal,
      }).then((res) => {
        setTags(res);
      });
    },
    [signal]
  );

  const loadMethods = useCallback(() => {
    getMethodNames({
      signal,
    }).then((res) => {
      setMethods(res);
      loadTags();
    });
  }, [signal, loadTags]);

  const loadModules = useCallback(() => {
    getModuleNames({
      signal,
    }).then((res) => {
      setModules(res);
    });
  }, [signal]);

  const getCurrentNews = useCallback(() => {
    setLoading(true);

    getNews({
      id: id,
      signal,
    })
      .then((res) => {
        setNews(res);
        setImageSuccess(res.image !== "");
        setImageURL(res.image !== "" ? res.image : false);
        setContent(res.content);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id, signal]);

  const complete = (v) => {
    setLoading(true);

    updateNews({
      ...v,
      image: imageURL,
      content: content,
      id: id,
      link: news.link,
      signal,
    })
      .then(() => {
        navigate("/content/news");
        message({
          content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
          icon: "gremlin",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadMethods();
    loadModules();
    getCurrentNews();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <ErrorBoundary>
        <AdminHead
          description={"Update the news content here. The URL will not be changed. Only the first 3 tags are displayed, but all tags are searched."}
          link={"/content/news"}
          title={"Update an news"}
          tooltipText={"Back to news"}
        />
      </ErrorBoundary>
      {!loading && (
        <Row className="midi-form">
          <Col>
            <Form name="confirm" onFinish={(v) => complete(v)} onFinishFailed={(v) => incomplete(v)}>
              <ErrorBoundary>
                <NewsInputs
                  content={content}
                  imageSuccess={imageSuccess}
                  imageURL={imageURL}
                  methods={methods}
                  modules={modules}
                  news={news}
                  setContent={setContent}
                  setImageSuccess={setImageSuccess}
                  setImageURL={setImageURL}
                  setLoading={setLoading}
                  tags={tags}
                  reloadTags={loadTags}
                />
              </ErrorBoundary>
              <Row>
                <Col>
                  <Form.Item>
                    <Button type="primary" htmlType="submit" disabled={loading} loading={loading} className="margin-right-100">
                      Save
                    </Button>
                    <Button onClick={() => setShowModal(true)} disabled={loading} loading={loading}>
                      Preview content
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      )}
      <ModalContent visible={showModal} type="article" onCancel={() => setShowModal(false)}>
        <div className="content" dangerouslySetInnerHTML={{ __html: content }} />
      </ModalContent>
    </MainPage>
  );
};
